import React, {useEffect, useState, useRef} from 'react';
import { connect } from 'react-redux';
import "swiper/swiper.scss";
import Swiper from 'swiper';
import {isMobile} from 'react-device-detect';
import { removeCellularItem } from '../../../saleJetBlockSlice';
import close from './images/close.svg';

const CellularBannerList = (props) => {
  const swiperRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    let currentIndex = props.cellularSettingsList?.findIndex(x => x.isSelected );
    if(activeIndex != currentIndex){
      setActiveIndex(currentIndex);
      const swiper = new Swiper(swiperRef.current, {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 8,
        initialSlide: currentIndex,
        scrollbar:{ draggable: true },
        enabled: true,
        //setWrapperSize: true
      });
      swiperRef.current?.swiper.slideTo(currentIndex);
    }
  }, [props.cellularSettingsList]);

  function deleteCellularItem(event , phoneNumber){
    if (event && typeof event.stopPropagation === 'function') {
      event.stopPropagation();
    }

    props.removeCellularItem({phoneNumber: phoneNumber ?? ''});
  }

  return (
    <div className='cellular-banner-list'>
      {isMobile ?
      <div ref={swiperRef} className="swiper-container">
        <div className="swiper-wrapper">
          {props.cellularSettingsList?.map((item, index) => {
            const showRemoveBtn = item.isRemovableFromBanner;
            return(<div key={index} className={`swiper-slide ${activeIndex == index ? 'swiper-slide-active' : ''}`}>
              <div className={`cellular-item ${item.isSelected ? 'selected' : ''}`} onClick={()=> {props.onClick({item: item, index: index })}} ><span><span className='bold-text'>קו {index+1} </span><span className='phone-number'>{item.phoneNumberFormat} </span>{item.package.title && <span>| {item.package.title}</span>}</span>{showRemoveBtn &&
               <button className='delete-btn'  style={{backgroundImage: close.bg()}} onClick={(event) => deleteCellularItem(event, item.phoneNumber)} ></button>}</div>
            </div>)
          })}
        </div>
      </div>
      :
      <div className='cellular-wrapper'>
      {props.cellularSettingsList?.map((item, index) => {
          const showRemoveBtn = item.isRemovableFromBanner;
          return(<div key={index} className={`cellular-item ${item.isSelected ? 'selected' : ''}`} onClick={()=> {props.onClick({item: item, index: index })}} ><span><span className='bold-text'>קו {index+1} </span><span className='phone-number'>{item.phoneNumberFormat}</span> {item.package.title && <span>| {item.package.title}</span>} </span>
          {showRemoveBtn && 
          <button className='delete-btn' style={{backgroundImage: close.bg()}} onClick={() => deleteCellularItem(item.phoneNumber)}></button>}</div>)})}
      </div>
      }
    </div>
  );
};


const mapStateToProps = (state) => {
  return {

  };
};

const mapDispatchToProps = {
  removeCellularItem
};

export default connect(mapStateToProps, mapDispatchToProps)(CellularBannerList);

